import moment from "moment";
import MasterComponent from "../../../components/Forms";
import { MasterConfigs } from "../../../interfaces/entity";
import ProfileCard from "../../../components/ContactInfo/ProfileCard";
import { constants } from "../../../constants/common";
import { Button, Modal, Tag, Typography } from "antd";
import { useState } from "react";
import PendingApprovals from "./PendingApprovals";

const Policies = () => {
  const [policy, setPolicy] = useState(null);

  const modules = {
    toolbar: [
      [{ 'font': [] }],
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'script': 'sub' }, { 'script': 'super' }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
      [{ 'direction': 'rtl' }, { 'align': [] }],
      ['link', 'image', 'video', 'formula'],
      ['clean']
    ]
  };

  const formats = [
    'header', 'font',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image', 'video', 'color', 'background',
    'align', 'direction', 'script', 'formula'
  ];

  const policyConfig: MasterConfigs = {
    api: () => '/policy',
    title: 'Policies',
    isActionTab: true,
    modalTitle: (action) => `${action}  Policy`,
    getColumns: () => {
      return [
        {
          title: 'Category Name',
          dataIndex: 'category',
          key: 'category',
          render: (item) => item && item.name
        },
        {
          title: 'Name',
          dataIndex: 'policyName',
          key: 'policyName'
        },
        {
          title: 'Policy Document',
          dataIndex: 'policy',
          align: 'center',
          key: 'policy',
          render: (item, records) => item ? <Button type="link" onClick={() => setPolicy(records)}>View</Button> : 'N/A'
        },
        {
          title: 'Created By',
          dataIndex: 'addedBy',
          key: 'addedBy',
          render: (item) => <ProfileCard
            size={30}
            name={constants.GET_FULL_NAME(item)}
            avatarUrl={item?.avatar ? process.env.FILE_URL + item?.avatar : ''}
            role={item?.employeeId}
          />
        },
        {
          title: 'Approval Status',
          dataIndex: 'approvalStatusText',
          key: 'approvalStatus',
          render: (text, record) => {
            const status = record.approvalStatus || 'pending';
            let color = 'orange';
            if (status === 'approved') color = 'green';
            if (status === 'rejected') color = 'red';
            return <Tag color={color}>{text || 'Pending for approval'}</Tag>;
          }
        },
        {
          title: 'Rejection Reason',
          key: 'rejectionReason',
          width: 250,
          render: (_, record) => {
            // Find rejected approval and show its comments
            if (record.approvalStatus === 'rejected' && record.approvals) {
              const rejectedApproval = record.approvals.find((approval: any) => approval.status === 'rejected');
              if (rejectedApproval && rejectedApproval.comments) {
                return (
                  <Typography.Text type="danger" style={{ fontSize: '12px' }}>
                    {rejectedApproval.comments}
                  </Typography.Text>
                );
              }
            }
            return <Typography.Text type="secondary" style={{ fontSize: '12px' }}>-</Typography.Text>;
          }
        },
        {
          title: 'Created At',
          dataIndex: 'createdAt',
          key: 'createdAt',
          isSearch: true,
          render: (text) => {
            return moment(text).format('DD MMM YYYY');
          },
        },
      ];
    },
    getFormColumns: () => {
      return [
        {
          label: 'Policy Category',
          name: 'category',
          type: 'select',
          isCombo: true,
          rules: [{ required: true, message: 'Please select policy category' }],
        },
        {
          label: 'Policy Name',
          name: 'policyName',
          type: 'text',
          rules: [{ required: true, message: 'Please enter policy name' }],
        },
        {
          label: 'Description',
          name: 'description',
          type: 'quill',
          span: 24,
          rules: [{ required: true, message: 'Please enter description' }]
        },
      ];
    },
    combo: [
      {
        name: 'category',
        api: '/policy-category',
        idKey: '_id',
        render: (item) => item.name,
      }
    ],
    getData: () => ({}),
    actions: [
      { name: 'Add Policy', actionType: "Add" },
    ],
  };

  return <>
    <Modal title={policy?.policyName}
      open={!!policy}
      onCancel={() => setPolicy(null)}
      footer={null}
      width={1000}>
      <iframe height={'100%'} src={process.env.FILE_URL + policy?.policy} name={policy?.policyName} />
    </Modal >
    <div className="-mt-6">
      <MasterComponent config={policyConfig} />
    </div>
  </>

}

export default Policies;